import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const usePhotoClassifications = (props, swrOptions) => {
  return useCustomSWR(`/photoClassifications?${stringify(props)}`, swrOptions)
}
